import { get } from "./api_helper"

export async function getAllPages(url) {
  const rows = []
  let page = 1
  while (true) {
    const result = await get(url, { params: { page, limit: 100 } })
    const pageRows = Array.isArray(result?.data) ? result.data : []
    rows.push(...pageRows)
    if (!pageRows.length || result?.pagination?.hasNextPage !== true) return rows
    page += 1
  }
}
